import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { getSessionRegistrantDetails } from '../../Apis/ReportingReadApi';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';
import {
  GET_SESSION_REGISTRANTS_FAILURE,
  GET_SESSION_REGISTRANTS_REQUEST,
  GET_SESSION_REGISTRANTS_SUCCESS
} from './SessionRegistrantsActions';

export function* getSessionRegistrantsWatcher() {
  yield takeLatest(GET_SESSION_REGISTRANTS_REQUEST, getSessionRegistrantsWorker);
}

export function* getSessionRegistrantsWorker({ payload }) {
  const { sessionKey, pageNumber, filter, sort } = payload;
  try {
    const axiosResponse = yield call(getSessionRegistrantDetails, sessionKey, pageNumber, filter, sort);
    let registrants = axiosResponse.data._embedded ? axiosResponse.data._embedded.registrants : [];
    let page = axiosResponse.data.page;
    yield put({
      type: GET_SESSION_REGISTRANTS_SUCCESS,
      payload: { registrants, page, filter, sort }
    });
  } catch (error) {
    yield put({ type: GET_SESSION_REGISTRANTS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export default function* rootSaga() {
  yield all([fork(getSessionRegistrantsWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionRegistrants/SessionRegistrantsSagas.js